import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router";

import { SettingsPageMobile } from "../settings/SettingsPageMobile";

/**
 * On a phone, settings are the account sheet. The /settings route page is
 * still reachable (the changelog's back button, desktop account links after a
 * resize, a bookmarked URL) but under the floating chrome it reads as a
 * broken sheet, so it is replaced by Home with the sheet presented over it.
 *
 * Opened once Home has committed: the sheet closes itself on any route change,
 * so opening it in the same render as the redirect would close it at once.
 */
export const useSettingsRouteSheet = (openAccount: () => void): void => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const redirected = useRef(false);

  useEffect(() => {
    if (pathname === SettingsPageMobile.path) {
      redirected.current = true;
      navigate("/", { replace: true });
    } else if (redirected.current) {
      redirected.current = false;
      openAccount();
    }
  }, [pathname, navigate, openAccount]);
};
